export enum AutopilotStatus {
    /** The user or admin has opted out of the Autopilot feature. */
    optOut = -1,
    /** The user does not have a license ot use Autopilot. */
    unlicensed = 0,
    /** Autopilot is active on the thread. */
    activeOnThread = 1,
    /** Autopilot is not active on the thread. */
    inactiveOnThread = 2
}